"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Returns null if the supplied string is null or empty (or whitespace, you get that one for free)
 */

function isNullOrEmpty(str) {
  return !str || str == null || str.length === 0 || str.trim().length == 0;
}

exports.isNullOrEmpty = isNullOrEmpty;

function capitaliseFirstLetter(str) {
  return str.charAt(0).toUpperCase() + str.substring(1);
}

exports.capitaliseFirstLetter = capitaliseFirstLetter;

function splitIntoParagraphs(str) {
  if (!str || !str.length) {
    return [];
  } else {
    return str.split('\n\n').filter(function (x) {
      return x && x.length;
    });
  }
}

exports.splitIntoParagraphs = splitIntoParagraphs;

function createSnippet(str) {
  return str.substring(0, Math.min(str.length, 40));
}

exports.createSnippet = createSnippet;

function getStringOrUndefined(str) {
  if (str && str.trim().length > 0) {
    return str;
  } else {
    return undefined;
  }
}

exports.getStringOrUndefined = getStringOrUndefined;

function cropToLength(str, length) {
  if (str.length < length) {
    return str;
  } else {
    return str.substring(0, length);
  }
}

exports.cropToLength = cropToLength;

function makeSlug(str) {
  return str.replace('&', 'and').replace(/[^a-zA-Z0-9]/g, ' ').trim().replace(/ /g, '-').replace(/[-]{2,}/g, '-').toLowerCase();
}

exports.makeSlug = makeSlug;

function isEmailAddress(email) {
  return /\S+@\S+\.\S+/.test(email);
}

exports.isEmailAddress = isEmailAddress;

function ensureTrailingSlash(url) {
  if (isNullOrEmpty(url)) return url;
  return url[url.length - 1] === '/' ? url : url + '/';
}

exports.ensureTrailingSlash = ensureTrailingSlash;

function removeTrailingSlash(url) {
  if (isNullOrEmpty(url)) return url;
  return url[url.length - 1] === '/' ? url.substr(0, url.length - 1) : url;
}

exports.removeTrailingSlash = removeTrailingSlash;